import {
  Box,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Portal,
} from '@cardboard-ui/react';
import React, { PropsWithChildren } from 'react';
import { BaseMenuLinkProps, MenuLink } from '.';
import { DesktopMenuContext, useDesktopMenu } from './DesktopMenuContext';
import { MenuItemStack } from './MenuItemStack';

type CollapsingMenuSectionProps = PropsWithChildren<BaseMenuLinkProps>;

export const CollapsingMenuSection = ({
  children,
  ...menuLinkProps
}: CollapsingMenuSectionProps) => {
  const { isCollapsed } = useDesktopMenu();

  if (!isCollapsed) {
    return <>{children}</>;
  }

  return (
    <Popover placement="auto-end">
      {({ onClose }: { onClose: () => void }) => (
        <>
          <PopoverTrigger>
            <Box>
              <MenuItemStack>
                <MenuLink to="" {...menuLinkProps} />
              </MenuItemStack>
            </Box>
          </PopoverTrigger>
          <Portal>
            <PopoverContent width={72} onClick={onClose}>
              <PopoverArrow />
              <PopoverBody>
                <DesktopMenuContext.Provider value={{ isCollapsed: false }}>
                  {children}
                </DesktopMenuContext.Provider>
              </PopoverBody>
            </PopoverContent>
          </Portal>
        </>
      )}
    </Popover>
  );
};
